<template>
  <div>
    <el-dialog :title="title"
               :visible="visible"
               center :width="controlWidth"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :modal-append-to-body="false"
               @close="onClose"
               :top="top">

      <auto-form ref="form" :rules="rules" :form="form" label-width="110px" :url="url" :labelPosition="labelPosition" :labelWidth="labelWidth" :isEdit="isEdit" :formTemplate="formTemplate" @saved="onSaved"
                 @beforeSave="beforeSave" @afterSaved="afterSaved" @onSavedError="onSavedError" :canEdit="canEdit">
        <slot></slot>
      </auto-form>
      <span slot="footer" class="dialog-footer">
      <slot name="footer">
        <el-button type="success" v-if="canEdit" :disabled="uploading" :loading="loading" plain @click="submitForm('form')"> 保 存 </el-button>
        <el-button type="warning" :disabled="uploading" :loading="loading" plain @click="onClose">{{ closeButton }}</el-button>
      </slot>
    </span>
    </el-dialog>
    <el-dialog center title="信息" :visible.sync="errorTable">
      <p style="margin-bottom: 10px;">以下提货单<span style="color: red;">预计皮重</span>超出了<span style="color: forestgreen;">皮重阈值</span>，是否继续创建提货单?，如需创建请点击继续保存按钮！</p>
      <el-table size="mini" :data="errorData" border>
        <el-table-column property="CarNumber" label="车牌号"></el-table-column>
        <el-table-column property="TruckWeigthPlan" label="预计皮重"></el-table-column>
        <el-table-column property="TruckWeigthLimit" label="皮重阈值"></el-table-column>
        <el-table-column property="TruckWeigthCha" label="超出阈值"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" :loading="loadingEnd" @click="submitLast">继续保存</el-button>
        <el-button type="danger" @click="errorTable = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog center title="确认车辆最小历史皮重" :visible.sync="errorTableFirst">
      <!--<p style="margin-bottom: 10px;">以下提货单<span style="color: red;">预计皮重</span>超出了<span-->
      <!--style="color: forestgreen;">皮重阈值</span>，是否继续创建提货单?，如需创建请点击继续保存按钮！</p>-->
      <el-table size="mini" :data="pWeightData" border>
        <el-table-column property="TruckNo" label="车牌号"></el-table-column>
        <el-table-column property="TruckWeigth" label="皮重"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="confirmLast">确定</el-button>
        <el-button type="danger" @click="errorTableFirst = false">取消</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  /**
   * @description 表单对话框
   * @author tyx
   * @example 使用方式
   * <dialog-form :title="title" :visible.sync="visible" :rules="rules" :form="form" :url="url" :type="optionType" @saved="onSaved()">
   *
   *   <!-- 这里放 el-form-item -->
   *   <el-form-item label="姓名">
   *     <el-input v-model="form.name" suffix-icon="fa fa-code" placeholder="请输入姓名" clearable></el-input>
   *   </el-form-item>
   *
   * </dialog-form>
   * @param title 对话框标题
   * @param visible 对话框是否显示
   * @param rules 表单验证
   * @param form 表单数据
   * @param url 数据保存地址
   * @param type 新增还是编辑 1 新增 2 编辑
   * @event saved 数据保存成功之后触发
   */

  import AutoForm from '@/components/AutoForm'

   export default {
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
      visible: {
        type: Boolean
      },
      rules: {
        type: Object
      },
      form: {
        type: Object
      },
      url: {
        type: String
      },
      type: {
        type: Number,
        default: 1
      },
      top: {
        type: String,
        default: '15vh'
      },
      isEdit: {
        type: Boolean,
        default: false
      },
      canEdit: {
        type: Boolean,
        default: true
      },
      formTemplate: {
          type: Array,
          default: () => []
      },
      width: {
        type: String
      },
      labelPosition: {
        type: String
      },
      labelWidth:{
        type: String
      }
    },
    components:{
      AutoForm
    },
    data() {
      return {
        errorTable:false,
        errorData:[],
        errorTableFirst:false,
        pWeightData:[],
        loadingEnd:false,
        uploading: false,
        first: true,
        fullscreenLoading:false,
        CheckModifyBillInfo: SZH.assets.api + '/Order/CheckModifyBillInfo',
        GetMinTruckWeigthConfim: SZH.assets.api + '/Order/GetMinTruckWeigthConfim',
      }
    },
    methods: {
      submitLast(formName){
        let self = this;
        // console.log(formName);
        // console.log(self.$refs[formName]);
        // this.$nextTick(() => {
        //   console.log(self.$refs[formName]);
        //   // self.$refs[formName].submit()
        // })
        // ;
        self.$refs['form'].validate(valid => {
          if (valid) {
            self.$emit('beforeSave');
            self.loadingEnd = true;
            self.$http.post(self.url, self.form).then(result => {
              if (result.state == true) {
                self.errorTable = false;
                self.$emit('saved', result.data);
              } else {
                self.$message.error(result.message);
              }
              self.loadingEnd = false;
              self.$emit('afterSaved');
            }, () => {
              self.loadingEnd = false;
              self.$message.error('数据保存失败，请检查您的网络是否可用。');
              self.$emit('onSavedError')
            });
          } else {
            return false;
          }
        });
      },
      //确认历史皮重
      submitBefore(){
        var self = this;
        self.$http.post(self.GetMinTruckWeigthConfim, {
          TruckNos: [self.form.CarNumber]
        }).then(result => {
          if (result.state == true) {
            self.errorTableFirst = true;
            self.pWeightData = result.data;
          } else {
            self.$message.error(result.message);
          }
        }, () => {
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
      confirmLast(){
        let self = this;
        self.errorTableFirst = false;
        self.$http.post(self.CheckModifyBillInfo, self.form).then(result => {
          if (result.state == true) {
            if(result.message != 'faile'){
              self.submitLast('form');
            }else{
              self.errorTable = true;
              self.errorData = [result.data];
            }
          } else {
            self.$message.error(result.message);
          }
        }, () => {
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
      submitForm(formName) {
        let self = this;
        //单独对修改提货单进行特殊处理
        if(self.title == '修改提货单'){
          self.submitBefore();

        }else{
          self.$refs[formName].submit();
        }
      },
      onSaved(form) {
        this.$emit('saved', form);
        this.$emit('update:visible', false);
      },
      onClose() {
        this.$emit('update:visible', false);
      },
      beforeSave() {
        this.uploading = true;
        this.$emit('beforeSave');
      },
      afterSaved() {
        this.uploading = false;
        this.$emit('afterSaved');
      },
      onSavedError(){
        this.uploading = false;
        this.$emit('afterSaved');
      }
    },
    watch: {
      visible(val) {
        if (!val || this.first) {
          if(this.first){
            this.first = false;

            this.$nextTick(() => {
              this.$refs['form'].initForm();
            });
          }
          else {
            setTimeout(() => {
              this.$refs['form'].initForm();
            }, 200);
          }
        }
        if(val) {
            this.$nextTick(() => {
              this.$refs['form'].clearValidate();
            });
        }
      }
    },
    computed:{
      controlWidth() {
        return this.width
      },
      closeButton() {
        return this.canEdit ? ' 取 消 ' : ' 关 闭 ';
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dialogs/DialogForm.vue